/**
 * Phase 6 React replacement for the global Flash singleton.
 *
 * Used by the existing `shared/flash.js` bridge so legacy Vue code and new
 * React code share the same message queue. Backed by Zustand for fine-grained
 * subscriptions; FlashNotify reads + drains it.
 */
import { create } from "zustand";

const FLASH_TYPES = ["success", "error", "info", "warning"];

export const useFlashStore = create((set, get) => ({
    messages: [],

    push(message, type = "success") {
        if (!FLASH_TYPES.includes(type)) type = "info";
        set((state) => ({
            messages: [...state.messages, { id: Date.now() + Math.random(), message, type }],
        }));
    },

    pop() {
        set((state) => ({ messages: state.messages.slice(1) }));
    },

    clear() {
        set({ messages: [] });
    },
}));

// Vue-compatible singleton API for incremental migration.
const Flash = {
    success(message) {
        useFlashStore.getState().push(message, "success");
    },
    error(message) {
        useFlashStore.getState().push(message, "error");
    },
    info(message) {
        useFlashStore.getState().push(message, "info");
    },
    warning(message) {
        useFlashStore.getState().push(message, "warning");
    },
    clearOne() {
        useFlashStore.getState().pop();
    },
    _getFlashMemory() {
        return useFlashStore.getState();
    },
};

export default Flash;
